var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M.5 11.5h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5l2 2-6 6-3 1 1-3 6-6z"
  }))));
}

export default SvgEditPen;